import { Component, inject, input, output, LOCALE_ID, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrentStockItem } from '../../../../pages/admin-dashboard/stock-management/stock.model';
import { ActionIcon } from '../../../../shared/ui/icons/action-icon/action-icon';
import { ToggleButton } from '../../../../shared/ui/toggle-button/toggle-button';
import { ConfirmationDialog } from '../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { StockService } from '../../../../services/product/stock/stock';
import { finalize } from 'rxjs';
import { SuccessfulNotification } from '../../../../utils/successful-notification/successful-notification';
import { Router } from '@angular/router';
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';
import { SCOPES } from '../../../../services/scope/scope-constants';
import { Pagination } from '../../../../shared/ui/shared-tables/pagination/pagination';
import { Tables } from '../../../../shared/ui/shared-tables/tables/tables';

@Component({
  selector: 'app-current-stock-table',
  standalone: true,
  imports: [CommonModule, ActionIcon, ToggleButton, ConfirmationDialog, SuccessfulNotification, HasScopeDirective, Pagination, Tables],
  templateUrl: './current-stock-table-component.html',
})
export class CurrentStockTableComponent {
  private stockService = inject(StockService);
  private router = inject(Router);

  readonly mockData: CurrentStockItem[] = [
    {
      id: '1',
      product: {
        id: 1,
        titleEn: 'Concor 5mg 30 Tab',
        titleAr: 'كونكور 5 مجم 30 قرص',
        profileImageFid: '666',
      },
      quantity: 120,
      mfgDate: '2024-02-01',
      expDate: '2027-02-01',
      batchNumber: 'CON-003',
      peoplePrice: 60.0,
      sellerPrice: 45.0,
      sellerPriceDiscountPercentage: 5,
      pharmacyPrice: 48.0,
      pharmacyPriceDiscountPercentage: 0,
      availableQuantity: 120,
      totalQuantity: 150,
      isActive: true,
      lastModifiedBy: { id: 2, fullName: 'Ahmed Hassan' },
      lastModifiedOn: '2025-04-01T10:30:00',
    },
    {
      id: '2',
      product: {
        id: 2,
        titleEn: 'Zithromax 500mg',
        titleAr: 'زيثرومكس 500 مجم',
        profileImageFid: '667',
      },
      quantity: 0,
      mfgDate: '2023-01-01',
      expDate: '2025-01-01',
      batchNumber: 'ZIT-105',
      peoplePrice: 160.0,
      sellerPrice: 120.0,
      sellerPriceDiscountPercentage: 0,
      pharmacyPrice: 128.0,
      pharmacyPriceDiscountPercentage: 10,
      availableQuantity: 0,
      totalQuantity: 40,
      isActive: false,
      lastModifiedBy: { id: 3, fullName: 'Sara Ali' },
      lastModifiedOn: '2025-03-15T08:00:00',
    },
    {
      id: '3',
      product: {
        id: 3,
        titleEn: 'Controloc 40mg',
        titleAr: 'كونترولوك 40 مجم',
        profileImageFid: '668',
      },
      quantity: 85,
      mfgDate: '2024-08-01',
      expDate: '2026-08-01',
      batchNumber: 'CTRL-88',
      peoplePrice: 112.0,
      sellerPrice: 84.0,
      sellerPriceDiscountPercentage: 12,
      pharmacyPrice: 89.6,
      pharmacyPriceDiscountPercentage: 0,
      availableQuantity: 85,
      totalQuantity: 100,
      isActive: true,
      lastModifiedBy: { id: 1, fullName: 'Mohamed Omar' },
      lastModifiedOn: '2025-04-10T14:20:00',
    },
  ];

displayData = computed(() => this.allStockData());
  private locale = inject(LOCALE_ID);
  confirmationModal = signal<boolean>(false);
  type = signal<'deactivate' | 'activate' | null>(null);

  allStockData = input.required<CurrentStockItem[]>();
  startItem = input.required<number>();
  totalItems = input.required<number>();
  currentPage = input.required<number>();
  itemsPerPage = input.required<number>();
  totalPages = input.required<number>();
  pageNumbers = input.required<number[]>();
  productId = input<string | null>(null);

  isDropDown = signal<string | null>(null);
  localActiveState = signal<Record<string, boolean>>({});
  stockIdToActivate = signal<string | null>(null);
  loadingActivation = signal(false);
  errorActivation = signal('');
  isSuccessNotification = signal<boolean>(false);
  readonly scopes = SCOPES;

  isAr = computed(() => this.locale.startsWith('ar'));
  currency = computed(() => (this.isAr() ? 'ج.م' : 'EGP'));
  discountLabel = computed(() => (this.isAr() ? 'خصم' : 'Disc.'));
  mfgLabel = computed(() => (this.isAr() ? 'تصنيع:' : 'MFG:'));
  expLabel = computed(() => (this.isAr() ? 'إنتهاء:' : 'EXP:'));

  activeStockIds = computed(
    () =>
      new Set(
        this.displayData()!
          .filter((p) => p.isActive)
          .map((p) => p.id),
      ),
  );

  previousPage = output<void>();
  nextPage = output<void>();
  goToPage = output<number>();
  pageSizeChange = output<number>();

  mathMin = Math.min;

  getStartItem = computed(() => (this.currentPage() - 1) * this.itemsPerPage() + 1);
  // getEndItem = computed(() => Math.min(this.currentPage() * this.itemsPerPage(), this.totalItems()));
  getEndItem = computed(() =>
  Math.min(
    this.startItem() + this.itemsPerPage() - 1,
    this.totalItems()
  )
);

  // getPageNumbers = computed(() => {
  //   const pages = [];
  //   const total = this.totalPages();
  //   const current = this.currentPage();

  //   for (let i = 1; i <= total; i++) {
  //     if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
  //       pages.push(i);
  //     } else if (pages[pages.length - 1] !== -1) {
  //       pages.push(-1);
  //     }
  //   }
  //   return pages;
  // });

  // onPageSizeChange(event: any) {
  //   this.pageSizeChange.emit(Number(event.target.value));
  // }
  onPaginationPageSizeChange(size: number) {
  this.pageSizeChange.emit(size);
}
  getTranslatedTitle(item: any): string {
    return this.locale.startsWith('ar') ? item?.titleAr || item?.titleEn : item?.titleEn || item?.titleAr;
  }

  isExpired(date: string): boolean {
    return new Date(date) < new Date();
  }

  isNearExpiry(date: string): boolean {
    const expiry = new Date(date);
    const today = new Date();
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(today.getMonth() + 3);
    return expiry > today && expiry <= threeMonthsFromNow;
  }

  openDropDown({ entityId }: { entityId?: string }) {
    this.isDropDown.set(entityId!);
  }

  closeDropDown() {
    this.isDropDown.set(null);
  }

  getStatusLabel(isActive: boolean): string {
    if (this.locale.startsWith('ar')) {
      return isActive ? 'مفعل' : 'غير مفعل';
    }
    return isActive ? 'Activated' : 'Deactivated';
  }

  // isStockActive(stockId: string): boolean {
  //   const local = this.localActiveState();
  //   if (local.has(stockId)) return local.get(stockId)!;
  //   // Fall back directly to the raw data, not the computed Set
  //   return this.displayData().find((p) => p.id === stockId)?.isActive ?? false;
  // }

  // In your .ts
  stockActiveMap = computed(() => {
    const local = this.localActiveState();
    const result = new Map<string, boolean>();
    for (const item of this.displayData()) {
      result.set(item.id, item.id in local ? local[item.id] : item.isActive);
    }
    return result;
  });

  onActiveConfirmationModal(isActive: boolean, stockId: string) {
    this.confirmationModal.set(true);
    this.errorActivation.set('');
    console.log('isActive: ', isActive);
    this.type.set(isActive ? 'deactivate' : 'activate');

    console.log(this.type());
    this.stockIdToActivate.set(stockId.toString());
  }

  onCancelConfirmationModal() {
    this.confirmationModal.set(false);
    this.type.set(null);
  }

  deactivateStock() {
    this.loadingActivation.set(true);
    this.stockService
      .deactivateStock(this.stockIdToActivate()!)
      .pipe(finalize(() => this.loadingActivation.set(false)))
      .subscribe({
        next: () => {
          console.log('API success, updating localActiveState for id:', this.stockIdToActivate());
          this.localActiveState.update((state) => ({ ...state, [this.stockIdToActivate()!]: false }));
          console.log('localActiveState after update:', this.localActiveState());
          this.confirmationModal.set(false);
          this.isSuccessNotification.set(true);
          setTimeout(() => {
            // this.onCancelConfirmationModal();
            this.isSuccessNotification.set(false);
          }, 2000);
        },
        error: (err) => {
          this.errorActivation.set(
            this.isAr() ? err.messageAr || 'حدث بعض الخطأ' : err.messageEn || 'some error occured!',
          );
        },
      });
  }
  activateStock() {
    this.loadingActivation.set(true);

    this.stockService
      .activateStock(this.stockIdToActivate()!)
      .pipe(finalize(() => this.loadingActivation.set(false)))
      .subscribe({
        next: () => {
          console.log('API success, updating localActiveState for id:', this.stockIdToActivate());
          this.localActiveState.update((state) => ({ ...state, [this.stockIdToActivate()!]: true }));
          console.log('localActiveState after update:', this.localActiveState());
          this.confirmationModal.set(false);
          this.isSuccessNotification.set(true);
          setTimeout(() => {
            // this.onCancelConfirmationModal();
            this.isSuccessNotification.set(false);
          }, 2000);
        },
        error: (err) => {
          this.errorActivation.set(
            this.isAr() ? err?.error?.messageAr || 'حدث بعض الخطأ' : err?.error?.messageEn || 'some error occured!',
          );
        },
      });
  }

  confirmationModalContent = computed(() => {
    const ar = this.isAr();
    const type = this.type();
    const loading = this.loadingActivation();

    if (!type) return null;

    const content = {
      deactivate: {
        title: ar ? 'تأكيد إلغاء التفعيل' : 'Confirm Deactivation',
        description: ar
          ? 'هل أنت متأكد من رغبتك في إلغاء تفعيل هذا المخزون؟'
          : 'Are you sure you want to deactivate this stock record?',
        confirmContent: ar
          ? loading
            ? 'جارٍ إلغاء التفعيل...'
            : 'تأكيد إلغاء التفعيل'
          : loading
            ? 'Deactivating...'
            : 'Confirm Deactivation',
      },
      activate: {
        title: ar ? 'تأكيد تفعيل المخزون' : 'Confirm Offer Activation',
        description: ar
          ? 'هل أنت متأكد من رغبتك في تفعيل هذا المخزون؟ '
          : 'Are you sure you want to activate this stock record?',
        confirmContent: ar
          ? loading
            ? 'جارٍ التفعيل...'
            : 'تأكيد التفعيل'
          : loading
            ? 'Activating...'
            : 'Confirm Activation',
      },
    };

    return content[type!];
  });

  onNavigateToEditStock(event: Event, stockId: string) {
    event.stopPropagation();
    this.router.navigate(['/admin/stock/edit-stock', stockId]);
  }


  readonly translations = {
    product: $localize`:@@stock.colProduct:Product`,
    subProduct: $localize`:@@stock.colSubProduct:Sub-Product`,
    mfgExp: $localize`:@@stock.colMfgExp:MFG / Expiry Date`,
    batch: $localize`:@@stock.Batch:Batch No.`,
    peoplePrice: $localize`:@@stock.colPeoplePrice:People Price`,
    seller: $localize`:@@stock.Seller:Seller Price & Discount`,
    pharmacy: $localize`:@@stock.Pharmacy:Pharmacy Price & Discount`,
    quantity: $localize`:@@stock.colQty:Available / Total Quantity`,
    status: $localize`:@@stock.colStatus:Status`,
    modified: $localize`:@@stock.colModified:Last Modified On / By`,

    addQuantity: $localize`:@@stock.addQuantity:Add Quantity`,
    mfg: $localize`:@@stock.mfg:MFG:`,
    exp: $localize`:@@stock.exp:EXP:`,
    activated: $localize`:@@stock.activated:Activated`,
    deactivated: $localize`:@@stock.deactivated:Deactivated`,
    markInactive: $localize`:@@stock.markInactive:Mark as inactive`,
    markActive: $localize`:@@stock.markActive:Mark as active`,

    noData: $localize`:@@stock.noData:No data available`,
    noDataDescription: $localize`:@@stock.noDataDescription:There is no stock data to display`,
    noFilterData: $localize`:@@stock.noFilterData:No data matches the applied filters`,
  };

stockTableColumns = computed(() => [
  {
    key: 'index',
    label: '#',
    type: 'index',
  },
  {
    key: 'product',
    label: this.productId()
      ? this.translations.subProduct
      : this.translations.product,
    type: 'stockProduct',
  },
  {
    key: 'mfgExp',
    label: this.translations.mfgExp,
    type: 'stockMfgExp',
  },
  {
    key: 'peoplePrice',
    label: this.translations.peoplePrice,
    type: 'stockPeoplePrice',
  },
  {
    key: 'sellerPrice',
    label: this.translations.seller,
    type: 'stockPriceDiscount',
  },
  {
    key: 'pharmacyPrice',
    label: this.translations.pharmacy,
    type: 'stockPriceDiscount',
  },
  {
    key: 'quantity',
    label: this.translations.quantity,
    type: 'stockQuantity',
  },
{
  key: 'status',
  label: this.translations.status,
  type: 'stockStatus',
},
  {
    key: 'lastModified',
    label: this.translations.modified,
    type: 'stockLastModified',
  },
  {
    key: 'actions',
    label: '',
    type: 'actions',
  },
]);
// stockTableRows = computed(() =>
// this.displayData().map((item, index) => ({
//     ...item,
//  isActive: this.stockActiveMap().get(item.id) ?? item.isActive,

//     index: this.startItem() + index,

//     product: item.product,

//     mfgExp: {
//       mfgDate: item.mfgDate,
//       expDate: item.expDate,
//       batchNumber: item.batchNumber,
//     },

//     sellerPrice: {
//       price: item.sellerPrice,
//       discount: item.sellerPriceDiscountPercentage,
//     },

//     pharmacyPrice: {
//       price: item.pharmacyPrice,
//       discount: item.pharmacyPriceDiscountPercentage,
//     },

//     quantity: {
//       available: item.availableQuantity,
//       total: item.totalQuantity,
//     },

//     lastModified: {
//       date: item.lastModifiedOn,
//       by: item.lastModifiedBy?.fullName,
//     },
//   })),
// );
stockTableRows = computed(() =>
  this.displayData().map((item, index) => {
    const isActive =
      this.stockActiveMap().get(item.id) ?? item.isActive;

    return {
      ...item,

      index: this.startItem() + index,

      product: item.product,

      mfgExp: {
        mfgDate: item.mfgDate,
        expDate: item.expDate,
        batchNumber: item.batchNumber,

        mfgLabel: this.translations.mfg,
        expLabel: this.translations.exp,
        batchLabel: this.translations.batch,
      },

      peoplePrice: {
        price: item.peoplePrice,
      },

      sellerPrice: {
        price: item.sellerPrice,
        discount: item.sellerPriceDiscountPercentage,
      },

      pharmacyPrice: {
        price: item.pharmacyPrice,
        discount: item.pharmacyPriceDiscountPercentage,
      },

      quantity: {
        available: item.availableQuantity,
        total: item.totalQuantity,
      },

      isActive,

    status: {
  label: isActive
    ? this.translations.activated
    : this.translations.deactivated,
},

      lastModified: {
        date: item.lastModifiedOn,
        by: item.lastModifiedBy?.fullName,
      },
    };
  }),
);

stockActions = computed(() => [
  {
    id: 1,
    titleEn: this.translations.addQuantity,
    titleAr: this.translations.addQuantity,
  },
  {
    id: 2,
    titleEn: this.translations.markInactive,
    titleAr: this.translations.markInactive,
    scope: String(this.scopes.STOCK.DEACTIVATE),
  },
  {
    id: 3,
    titleEn: this.translations.markActive,
    titleAr: this.translations.markActive,
    scope: String(this.scopes.STOCK.ACTIVATE),
  },
]);

onStockAction(event: {
  actionId: number;
  row: Record<string, any>;
}) {
  const stockId = String(event.row['id']);

  if (event.actionId === 1) {
    this.router.navigate(['/admin/stock/edit-stock', stockId]);
    return;
  }

  if (event.actionId === 2) {
    this.onActiveConfirmationModal(true, stockId);
    return;
  }

  if (event.actionId === 3) {
    this.onActiveConfirmationModal(false, stockId);
    return;
  }
}

emptyContentTitle = computed(() =>
  this.isAr()
    ? 'لا توجد بيانات'
    : 'No data available',
);

emptyContentDescription = computed(() =>
  this.isAr()
    ? 'لا توجد بيانات مخزون لعرضها'
    : 'There is no stock data to display',
);
  
}
